import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

export function phoneNumberValidator(): ValidatorFn {
    const phoneNumberUtil = PhoneNumberUtil.getInstance();
  
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const phoneNumberControl = formGroup.get('phoneNumber');
      const phoneAreaCodeControl = formGroup.get('phoneAreaCode');
  
      if (!phoneNumberControl || !phoneAreaCodeControl) {
        return null;
      }
  
      const phoneNumber = phoneNumberControl.value;
      const phoneAreaCode = phoneAreaCodeControl.value;
  
      if (!phoneNumber || !phoneAreaCode) {
        return null;
      }
  
      try {
        const fullPhoneNumber = phoneAreaCode + phoneNumber;
        const parsedNumber = phoneNumberUtil.parseAndKeepRawInput(fullPhoneNumber);
  
        const isValid = phoneNumberUtil.isValidNumber(parsedNumber);
        if (!isValid) {
          phoneNumberControl.setErrors({ invalidPhoneNumber: true });
          return { invalidPhoneNumber: true };
        }
  
        phoneNumberControl.setErrors(null);
        return null;
      } catch (error) {
        phoneNumberControl.setErrors({ invalidPhoneNumber: true });
        return { invalidPhoneNumber: true };
      }
    };
}